import ConnectionTypes from 'automation-ui-action-features/constants/ConnectionTypes';
import { LIST_BRANCH, STATIC_BRANCH, WHILE_LOOP, AB_TEST_BRANCH } from 'automation-ui-action-features/constants/ActionTypes';
import { getConnection } from 'automation-ui-action-features/records/recordsUtils';
import SingleConnection from 'automation-ui-action-features/records/connection/SingleConnection';
import ListBranchConnection from 'automation-ui-action-features/records/connection/ListBranchConnection';
import StaticBranchConnection from 'automation-ui-action-features/records/connection/StaticBranchConnection';
import LoopConnection from 'automation-ui-action-features/records/connection/LoopConnection';
import ABTestBranchConnection from 'automation-ui-action-features/records/connection/ABTestBranchConnection';
const getIsListBranchConnection = actionOptions => {
  const rawConnection = getConnection(actionOptions);
  const connectionType = rawConnection && rawConnection.connectionType;
  const actionType = actionOptions.actionType;
  return connectionType === ConnectionTypes.LIST_BRANCH_CONNECTION || actionType === LIST_BRANCH;
};
const getIsStaticBranchConnection = actionOptions => {
  const rawConnection = getConnection(actionOptions);
  const connectionType = rawConnection && rawConnection.connectionType;
  const actionType = actionOptions.actionType;
  return connectionType === ConnectionTypes.STATIC_BRANCH_CONNECTION || actionType === STATIC_BRANCH;
};
const getIsABTestBranchConnection = actionOptions => {
  const rawConnection = getConnection(actionOptions);
  const connectionType = rawConnection && rawConnection.connectionType;
  const actionType = actionOptions.actionType;
  return connectionType === ConnectionTypes.AB_TEST_BRANCH_CONNECTION || actionType === AB_TEST_BRANCH;
};
const getIsLoopConnection = actionOptions => {
  const rawConnection = getConnection(actionOptions);
  const connectionType = rawConnection && rawConnection.connectionType;
  const actionType = actionOptions.actionType;
  return connectionType === WHILE_LOOP || actionType === WHILE_LOOP;
};
export const buildConnectionForAction = actionOptions => {
  const rawConnection = getConnection(actionOptions);
  if (getIsListBranchConnection(actionOptions)) {
    return new ListBranchConnection(rawConnection || {});
  } else if (getIsStaticBranchConnection(actionOptions)) {
    return new StaticBranchConnection(rawConnection || {});
  } else if (getIsLoopConnection(actionOptions)) {
    return new LoopConnection(rawConnection || {});
  } else if (getIsABTestBranchConnection(actionOptions)) {
    return new ABTestBranchConnection(rawConnection || {});
  } else if (rawConnection === null) {
    return null;
  }
  return new SingleConnection(rawConnection);
};